const OUTLINE_CLASS_NAME = 'seam-outline';

let previousSectionEl = null;
let previousContentEl = null;
let hasHeaderStyle = false;

function seamConnector() {

    window.addEventListener('message', ({data}) => {
        handleHighlight(data);
    });

}


function handleHighlight(data) {
    handleSection(data);
}


function getContentEl(content,sectionEl) {

    return sectionEl.querySelector(`[data-seam-tag="${generateContentTag(content)}"]`);
}

function handleContent(data, sectionEl) {

    if(data.content) {
        if(!hasHeaderStyle) {
            addHeaderStyle();
        }

        let contentEl = getContentEl(data.content, sectionEl);

        if(contentEl) {
            if(previousContentEl) {
                previousContentEl.classList.remove(OUTLINE_CLASS_NAME);
            }
            contentEl.classList.add(OUTLINE_CLASS_NAME);
            if(data.type === 'change') {
                contentEl.innerHTML = data.changeData;
            }
            previousContentEl = contentEl;
        }else {
            if(previousContentEl) {
                previousContentEl.classList.remove(OUTLINE_CLASS_NAME);
            }
        }

    }else {
        if(previousContentEl) {
            previousContentEl.classList.remove(OUTLINE_CLASS_NAME);
        }
    }
}

function getElementByTag(tag) {
    return document.querySelector(`[data-seam-tag="${tag}"]`);
}

function handleSection(data) {
    if (data.section) {
        if (!hasHeaderStyle) {
            addHeaderStyle();
        }
        let sectionEl = getElementByTag(generateSectionTag(data.section));
        if(sectionEl) {
            if(previousSectionEl) {
                previousSectionEl.classList.remove(OUTLINE_CLASS_NAME)
            }
            sectionEl.classList.add(OUTLINE_CLASS_NAME);
            previousSectionEl = sectionEl;
            handleContent(data, sectionEl);
        }
    }else {
        if(previousSectionEl) {
            previousSectionEl.classList.remove(OUTLINE_CLASS_NAME);
        }
    }
}

function addHeaderStyle() {
    let css = '.seam-outline { box-shadow: inset 0 0 50px #1577EA; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
    hasHeaderStyle = true;
}

function generateSectionTag(section) {
    return btoa(`section${section.name}`);
}

function generateContentTag(content) {

    return btoa(`content-item${content.name}`);
}

seamConnector();
